import React from 'react'
import { Badge, Spinner, Typography } from '@telavita-core/react-design-kit'
import { LabelList, LineChart, XAxis, Line, ResponsiveContainer } from 'recharts'

import { handleDataColor, replaceDotWithComma } from '../../utils'
import { CustomizedDot, CustomizedLabelGraph } from '../CustomizedGraphicElements'
import { IMonthlyNpsAverage } from '../../hooks/useGetProfessionalNPS'

import { 
  GraphicWrapper, 
  LeftSection,
  LeftSectionText,
  BadgeText, 
  Loading
} from './styles'

interface NPSGraphicProps {
  loading: boolean
  biannualNps: number
  npsData: IMonthlyNpsAverage[]
}

export const NPSGraphic = ({ loading, biannualNps, npsData }: NPSGraphicProps): JSX.Element => {
  const formattedBiannualNps = replaceDotWithComma(biannualNps?.toFixed(1))

  return (
    <>
      {loading && (
        <Loading>
          <Spinner />
        </Loading>
      )}
      <GraphicWrapper isLoading={loading} isEmpty={false}>
        <LeftSection>
          <Typography
            weight='bolder'
            inlineStyles={{
              fontSize: '35px',
              lineHeight: '35px',
              color: handleDataColor(biannualNps)
            }}
          >
            {formattedBiannualNps}
          </Typography>
          <LeftSectionText>
            Média dos<br />
            últimos<br />
            6 meses
          </LeftSectionText>
          <Badge colorScheme='grey'>
            <BadgeText>
              IDEAL:<br />
              90 a 100
            </BadgeText>
          </Badge>
        </LeftSection>

        <ResponsiveContainer width='100%' height={120}>
          <LineChart
            margin={{
              left: 30,
              right: 30,
              top: 30
            }}
            data={npsData}
          >
            <Line
              dataKey='average'
              stroke='#e2e2e2'
              dot={<CustomizedDot />}
              animationDuration={500}
            > 
              <LabelList
                content={
                  <CustomizedLabelGraph />
                }
              />
            </Line>
            <XAxis
              dataKey='month'
              type='category'
              name='month'
              axisLine={false}
              tickLine={false}
              xAxisId={0}
              fontSize={12}
              stroke='#4b4b4b'
              style={{
                textTransform: 'capitalize'
              }}
            />
            <XAxis
              dataKey='year'
              type='category'
              name='year'
              axisLine={false}
              tickLine={false}
              xAxisId={1}
              dy={-15}
              dx={-3}
              height={5}
              fontSize={12}
              stroke='#adadad'
            />
          </LineChart>
        </ResponsiveContainer>
      </GraphicWrapper>
    </>
  )
}